let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jjh1v")).then(() => parcelRequire('2TL59'));